/*@ngInject*/
const BaseDataSetFormComponentController = function ($scope, $q, $stateParams, coreMediator, formComponentUtil, formViewerConstant, dataSetType, dataSetUtil) {

    this.supportSearch = false;

    this.searchText = null;
    this.dataSetCount = null;
    this.showLoadingSpinner = false;

    this.setSearchText = function (searchText) {
        this.searchText = searchText;
    };

    this.isRowRepeater = function () {
        return _.isPlainObject(this.fieldStructure.rowRepeaterTemplate) && _.isPlainObject(this.fieldStructure.rowRepeaterModel);
    };

    this.onInitDataSetComponent = function (dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent) {
        const uiField = this.fieldStructure.uiField;
        const isConfigurableForm = this.fieldStructure.parentFormStructure && this.fieldStructure.parentFormStructure.isConfigurableForm;

        this.hideLabel = _.isNil(this.fieldStructure.hideLabel) ? this.hideLabel : this.fieldStructure.hideLabel;

        this.itemsList = [{}];
        this.dataSetName = uiField.fieldTemplate.dataSetName;

        if (!_.isEmpty(this.dataSetName)) {
            this.type = dataSetUtil.getDataSetType(this.dataSetName);

            if (preventDataSetLoadIfConfigurableComponent && isConfigurableForm) {
                return $q.when();
            } else if (!preventDataSetLoadIfConfigurableComponent && isConfigurableForm) {
                return this.loadConfigurableFormDataSet(dataSetImmediateLoad);
            } else {
                return this.loadDataSet(dataSetImmediateLoad);
            }
        } else {
            return $q.when();
        }
    };

    this.loadConfigurableFormDataSet = function () {
        return coreMediator.getRemoteDataSetByName(this.dataSetName).then((dataSet) => {
            this.setItemsList(dataSet.items);
        });
    };

    this.loadDataSet = function (dataSetImmediateLoad) {
        const isConfigurableForm = this.fieldStructure.parentFormStructure && this.fieldStructure.parentFormStructure.isConfigurableForm;

        if (dataSetImmediateLoad && !isConfigurableForm) {
            this.showLoadingSpinner = true;
            return coreMediator.getCachedDataSetByName(this.dataSetName).then((dataSet) => {
                if (this.type === dataSetType.STATIC) {
                    this.showLoadingSpinner = false;
                    this.setItemsList(dataSet.items);
                } else {
                    this.supportSearch = dataSet.supportSearch;
                    this.minimumSearchLength = dataSet.minSearchStringLength;

                    if (!this.supportSearch || this.searchText && this.searchText.length >= dataSet.minSearchStringLength) {
                        const formId = this.fieldStructure.parentForm.id;

                        this.dynamicDataSetParams = dataSetUtil.getDataSetParamsByFieldStructure(dataSet, this.fieldStructure, this.searchText);

                        if (this.supportSearch) {
                            return coreMediator.getDynamicDataSet(this.dynamicDataSetParams, formId).then((dataSet) => {
                                this.dataSetCount = dataSet.count;
                                this.setItemsList(dataSet.items);
                            }).finally(() => {
                                this.showLoadingSpinner = false;
                            });
                        } else {
                            return dataSetUtil.getDataItems(this.dynamicDataSetParams, formId).then((items) => {
                                this.setItemsList(items);
                            }).finally(() => {
                                this.showLoadingSpinner = false;
                            });
                        }
                    } else {
                        this.showLoadingSpinner = false;
                    }
                }
            });
        } else {
            return $q.when();
        }
    };

    this.shouldUpdateItems = function (updateEvent, data) {
        if (!this.dynamicDataSetParams) {
            return false; // not yet initialized
        }

        const isCurrentComponent = (!this.isRowRepeater() && _.isEmpty(data.dynamicDataSetKey.formRowUri)) || this.dynamicDataSetParams.formRowUri === data.dynamicDataSetKey.formRowUri;
        const isDataSetName = data.name === this.dataSetName;
        const isDataSetVariableName = this.dynamicDataSetParams.variableName === data.dynamicDataSetKey.variableName;

        return isCurrentComponent && isDataSetName && isDataSetVariableName;
    };

    this.setItemsList = function (itemsList) {
        this.itemsList = _.cloneDeep(itemsList);
    };

    this.isItemsListEmpty = function () {
        return this.itemsList.length === 0 || (this.itemsList.length === 1 && _.isEmpty(this.itemsList[0]));
    };
};

angular.module('umFormViewer')
    .controller('baseDataSetFormComponentController', BaseDataSetFormComponentController);
